<template>
    <div class="centent">
        <div v-if="$store.state.settings.mode ==='pc'" class="logo">
            <img src="../assets/images/index/logo.png" alt="">
        </div>
        <div v-if="$store.state.settings.mode ==='pc'" class="header">
            <ul class="nav">
                <RouterLink v-if="navList.length" :to="{name: navList[0].routeName,params:navList[0].cId}" tag="li">{{ navList[0].cName }}</RouterLink>
                <RouterLink
                    v-for="(item, index) in navList.slice(1,8)"
                    :key="index"
                    :to="{name: item.routeName,params: {cId: item.cId,id:item.id}}"
                    tag="li"
                    replace
                >
                    {{ item.cName }}
                    <div v-if="item.children" class="introduce-box">
                        <ul class="nav-children">
                            <li v-for="(itemC, indexC) in item.children"
                                :key="indexC"
                                @mouseover="changeActive($event)" @mouseout="removeActive($event)"
                            >
                                <RouterLink
                                    class="nav-link"
                                    :to="{name: itemC.routeName}"
                                >
                                    <span v-if="!itemC.name">{{ itemC.name }}</span>
                                    <div v-else class="link-box">
                                        <span class="link-name">{{ itemC.name }}</span>
                                        <span class="link-icon">{{ itemC.icon }}</span>
                                    </div>
                                </RouterLink>
                            </li>
                        </ul>
                    </div>
                    <div v-if="item.childrens" class="introduce-box">
                        <ul class="nav-childrens">
                            <li v-for="(itemC, indexC) in item.childrens"
                                :key="indexC"
                                @mouseover="changeActive($event)" @mouseout="removeActive($event)"
                            >
                                <RouterLink
                                    class="nav-link"
                                    :to="{name: itemC.routeName}"
                                >
                                    <span v-if="!itemC.name">{{ itemC.name }}</span>
                                    <div v-else class="link-box">
                                        <span class="link-name">{{ itemC.name }}</span>
                                        <span class="link-icon">{{ itemC.icon }}</span>
                                    </div>
                                </RouterLink>
                            </li>
                        </ul>
                    </div>
                    <div v-else class="introduce-box">
                        <ul class="nav-childrenss">
                            <li v-for="(itemS, indexS) in item.childrenss"
                                :key="indexS"
                                @mouseover="changeActive($event)" @mouseout="removeActive($event)"
                            >
                                <div v-if="itemS.is_url == 0">
                                    <RouterLink
                                        class="nav-link"
                                        :to="{path: '/'+itemS.routeName,params:{name:itemS}}"
                                    >
                                        <span>{{ itemS.name }}</span>
                                    </RouterLink>
                                </div>
                                <div v-else class="herfBox">
                                    <span @click="herfUrl(itemS.url)">{{ itemS.name }}</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </RouterLink>
                <!-- <li @click="jumpUrl('http://mc.cmca.org.cn/')">
                    市场监测
                </li> -->
                <li v-for="(item, index) in navList.slice(-1)" :key="index.length" class="wxCode">
                    {{ item.cName }}
                    <div class="wx-code-box">
                        <img :src="wxCode.image" alt="">
                    </div>
                </li>
                <!-- X<RouterLink :to="{name: navList[0].routeName,params:navList[0].cId}" tag="li">证件查询</RouterLink> -->
                <!-- <RouterLink :to="{name: 'certificateInquiry'}" tag="li">证件查询</RouterLink> -->
                <!-- x<RouterLink :to="{name: 'queryResults'}" tag="li">证件查询</RouterLink> -->
            </ul>
        </div>
        <!-- 移动端头部 -->
        <MobileHeader v-if="$store.state.settings.mode ==='mobile'" :activity="activityList" />
        <router-view />
        <div v-if="$store.state.settings.mode ==='pc'" :class="bol === 'false' ? 'footer':'footer bright' ">
            <div class="container">
                <div class="footer-content">
                    <div class="footer-left">
                        <h4>{{ footerTitleLeft }}</h4>
                        <ul>
                            <li v-for="(item, index) in footerLeft" :key="index">
                                <a :href="item.url ? item.url : 'javascript:;'" target="_blank">
                                    <img :src="item.image" alt="" :title="item.name">
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="footer-bottom">
                        <span class="footer-number">
                            <a href="http://www.beian.miit.gov.cn" target="_blank">中国移动通信联合会 China Mobile Communication Association © CopyRight 2014 京ICP备08105208号</a>
                        </span>
                    </div>
                </div>
                <div class="footer-right">
                    <h4>{{ footerTitleRight }}</h4>
                    <div class="img">
                        <img :src="wxCode.image" alt="">
                    </div>
                    <span class="code-title">扫码关注官方微信</span>
                </div>
            </div>
        </div>
        <!-- 移动端底部 -->
        <MobileFooter v-if="$store.state.settings.mode ==='mobile'" />
    </div>
</template>
<script>
// 移动端组件
import MobileHeader from '@/views/compontents/home/header.vue'
import MobileFooter from '@/views/compontents/home/footer.vue'
export default {
    name: 'EmptyLayout',
    components: {
        MobileHeader,
        MobileFooter
    },
    data() {
        return {
            footerLeft: [],
            footerTitleLeft: '友情链接',
            footerTitleRight: '官方微信',
            navList: [

            ],
            wxCode: [],
            activityList: [],
            arr: [],
            bol: '',
            RootUrlData: ''
        }
    },
    watch: {
        '$route.path': function(newVal, oldVal) {
            if (newVal != oldVal) {
                this.bol = this.$router.currentRoute.meta.color
                this.getActivityList()
            }
        }
    },
    mounted() {
        this.bol = this.$router.currentRoute.meta.color
        this.bright()
        this.getFooterConnection()
        this.getFooterWxcode()
        this.getActivityList()
    },
    beforeCreate() {
        document.querySelector('body').setAttribute(
            'style',
            'margin: 0 auto; width: 100%; background:rgba(255, 255, 255, 1); overflow-x: hidden;height: 100%;')
    },
    methods: {
        jumpUrl(url) {
            location.href = url
        },
        fallback() {
            this.$router.go(-1)
        },
        fn() {
            this.$api.get('webInfo/formInfo').then(res => {
                var a = document.createElement('a')
                a.href = 'http://ydlhh.1daas.com/' + res.data.file
                a.target = '_blank'
                document.querySelector('body').appendChild(a)
                a.click()
                a.remove()
            })
        },
        herfUrl(url) {
            window.open(url)
        },
        changeActive($event) {
            $event.currentTarget.className = 'col-lg-3 col-xs-6 paddingLeft com_marginBtm10 choosePlan active'
        },
        removeActive($event) {
            $event.currentTarget.className = 'col-lg-3 col-xs-6 paddingLeft com_marginBtm10 choosePlan'
        },
        getRootUrl() {
            this.$api.get('webInfo/formInfo').then(res => {
                this.RootUrlData = res.data.file
            })
        },
        getFooterConnection() {
            this.$api.get('webInfo/friendlyLink').then(res => {
                this.footerLeft = res.data.list
            })
        },
        getFooterWxcode() {
            this.$api.get('webInfo/otherInfo').then(res => {
                this.wxCode = res.data

            })
        },
        getActivityList() {
            this.$api.get('webInfo/activeInfo').then(res => {
                this.activityList = res.data.list
                this.getNavList()
            })
        },
        bright() {
            if (this.bol) {
                return 'bright'
            }
        },
        getNavList() {
            this.$api.get('news/cList').then(res => {
                console.log(res.data)
                let arr = [{cName: '首页', routeName: 'index'}]
                let routeName = ''
                let typeId = ''
                res.data.list.map((item, index) => {
                    switch (index + 1) {
                        case 2:
                            routeName = 'synopsis'; break
                        case 6:
                            routeName = 'membership'; break
                        case 7:
                            routeName = 'activities'
                            typeId = '3'
                            break
                        default:
                            routeName = 'Policies'; break
                    }
                    item.id = typeId
                    item.routeName = routeName
                    if (item.cId == 2) {
                        item.children = [
                            {
                                name: '中国移动通信联合会简介',
                                routeName: 'synopsis'
                            },                       {
                                name: '领导成员',
                                routeName: 'member'
                            },                      {
                                name: '协会章程',
                                routeName: 'constitution'
                            },                      {
                                name: '组织机构图',
                                routeName: 'mechanism'
                            },
                            {
                                name: '联系方式',
                                icon: 'More >',
                                routeName: 'contact'
                            }
                        ]
                    } else if (item.cId == 7) {
                        item.childrens = [
                            {
                                name: '入会须知',
                                routeName: 'membership'
                            },
                            {
                                name: '会员服务细则',
                                routeName: 'vipRule'
                            },
                            {
                                name: '申请表下载',
                                icon: 'Download >',
                                routeName: 'download'
                            }]
                    } else if (item.cId == 8) {
                        item.childrenss = this.activityList
                    }
                    arr.push(item)
                })
                this.navList = arr
                console.log('arr', arr)
            })
        }
    }
}
</script>
<style lang="scss" scoped>
a {
    color: rgba(153, 153, 153, 1);
}
.downLoad {
    a {
        text-decoration: none;
    }
}
.centent {
    background: rgba(255, 255, 255, 1);
    .logo {
        width: 100%;
        // height: 160px;
        img {
            width: 100%;
            height: 100%;
            display: block;
            vertical-align: middle;
        }
    }
    .header {
        width: 100%;
        height: 60px;
        margin: 0 auto;
        border-bottom: 1px solid rgba(238, 238, 238, 1);
        .nav {
            width: 1170px;
            margin: 0 auto;
            display: flex;
            height: 100%;
            list-style: none;
            padding-left: 0;
            li {
                width: 110px;
                text-align: center;
                box-sizing: border-box;
                line-height: 60px;
                font-weight: 400;
                cursor: pointer;
                -moz-user-select: none; /* 火狐 */
                -webkit-user-select: none; /* webkit浏览器 */
                -ms-user-select: none; /* IE10 */
                -khtml-user-select: none; /* 早期浏览器 */
                user-select: none;
                font-size: 14px;
                color: rgba(51, 51, 51, 1);
                .wx-code-box {
                    display: none;
                    z-index: 9999;
                    list-style: none;
                    width: 210px;
                    height: 210px;
                    padding: 14px;
                    background: rgba(255, 255, 255, 1);
                    img {
                        width: 100%;
                        height: 100%;
                        display: block;
                    }
                }
                .nav-children {
                    display: none;
                    z-index: 9999;
                    list-style: none;
                    width: 210px;
                    padding-left: 0;
                    background: rgba(255, 255, 255, 1);
                    .nav-link {
                        display: block;
                        width: 100%;
                        height: 100%;
                        line-height: 48px;
                        font-size: 14px;
                        text-decoration: none;
                        .link-box {
                            display: flex;
                            justify-content: space-around;
                            .link-icon {
                                font-size: 14px;
                                font-weight: 400;
                                color: rgba(163, 179, 254, 1);
                                line-height: 48px;
                            }
                        }
                    }
                    li {
                        width: 210px;
                        height: 48px;
                        line-height: 48px;
                        font-size: 14px;
                        font-weight: 400;
                        display: flex;
                        justify-content: space-between;
                        &:hover {
                            background-color: red;
                        }
                    }
                }
                .nav-childrens {
                    display: none;
                    z-index: 9999;
                    list-style: none;
                    width: 210px;
                    padding-left: 0;
                    background: rgba(255, 255, 255, 1);
                    .nav-link {
                        display: block;
                        width: 100%;
                        height: 100%;
                        line-height: 48px;
                        font-size: 14px;
                        text-decoration: none;
                        .link-box {
                            display: flex;
                            justify-content: space-around;
                            .link-icon {
                                font-size: 14px;
                                font-weight: 400;
                                color: rgba(163, 179, 254, 1);
                                line-height: 48px;
                            }
                        }
                    }
                    li {
                        width: 210px;
                        height: 48px;
                        line-height: 48px;
                        font-size: 14px;
                        font-weight: 400;
                        display: flex;
                        justify-content: space-between;
                        &:hover {
                            background-color: red;
                        }
                        .link-boxs {
                            padding-left: 20px;
                            .link-icon {
                                padding-left: 20px;
                                font-size: 14px;
                                font-weight: 400;
                                color: #a3b3fe;
                                line-height: 48px;
                            }
                        }
                    }
                }
                .nav-childrenss {
                    display: none;
                    z-index: 9999;
                    list-style: none;
                    width: 210px;
                    padding-left: 0;
                    background: rgba(255, 255, 255, 1);
                    .nav-link {
                        display: block;
                        width: 100%;
                        height: 100%;
                        line-height: 48px;
                        font-size: 14px;
                        text-decoration: none;
                        .link-box {
                            display: flex;
                            justify-content: space-around;
                            .link-icon {
                                font-size: 14px;
                                font-weight: 400;
                                color: rgba(163, 179, 254, 1);
                                line-height: 48px;
                            }
                        }
                    }
                    li {
                        width: 210px;
                        height: 48px;
                        line-height: 48px;
                        font-size: 14px;
                        font-weight: 400;
                        display: flex;
                        justify-content: space-between;
                        &:hover {
                            background-color: red;
                        }
                        div {
                            width: 100%;
                            height: 100%;
                            a {
                                text-decoration: none;
                                line-height: 48px;
                                font-size: 14px;
                                text-align: center;
                                width: 100%;
                                height: 100%;
                                display: block;

                                /* 正常的未被访问过的链接 */
                                &:link {
                                    text-decoration: none;
                                }

                                /* 已经访问过的链接 */
                                &:visited {
                                    text-decoration: none;
                                }

                                /* 鼠标划过(停留)的链接 */
                                &:hover {
                                    text-decoration: none;
                                    color: rgba(255, 255, 255, 1);
                                }

                                /* 正在点击的链接 */
                                &:active {
                                    text-decoration: none;
                                }
                            }
                        }
                        .link-boxs {
                            padding-left: 20px;
                            .link-icon {
                                padding-left: 20px;
                                font-size: 14px;
                                font-weight: 400;
                                color: #a3b3fe;
                                line-height: 48px;
                            }
                        }
                        .herfBox {
                            width: 100%;
                            height: 100%;
                            span {
                                display: block;
                                width: 100%;
                                height: 100%;
                            }
                        }
                    }
                }
                &:hover .nav-childrenss {
                    position: absolute;
                    display: block;
                    z-index: 9999;
                    line-height: 48px;
                    font-size: 14px;
                    font-weight: 400;
                    background: rgba(255, 255, 255, 1);
                    li {
                        color: rgba(153, 153, 153, 1);
                        background: rgba(255, 255, 255, 1);
                    }
                    .active {
                        color: rgba(255, 255, 255, 1);
                        background: rgba(36, 61, 179, 1);
                        z-index: 9999;
                        ::v-deep .nav-link {
                            color: rgba(255, 255, 255, 1);
                        }
                    }
                }
                &:hover .nav-childrens {
                    position: absolute;
                    display: block;
                    z-index: 9999;
                    line-height: 48px;
                    font-size: 14px;
                    font-weight: 400;
                    background: rgba(255, 255, 255, 1);
                    li {
                        color: rgba(153, 153, 153, 1);
                        background: rgba(255, 255, 255, 1);
                    }
                    .active {
                        color: rgba(255, 255, 255, 1);
                        background: rgba(36, 61, 179, 1);
                        z-index: 9999;
                        ::v-deep .nav-link {
                            color: rgba(255, 255, 255, 1);
                        }
                    }
                }
                &:hover .nav-children {
                    position: absolute;
                    display: block;
                    z-index: 9999;
                    line-height: 48px;
                    font-size: 14px;
                    font-weight: 400;
                    background: rgba(255, 255, 255, 1);
                    li {
                        color: rgba(153, 153, 153, 1);
                        background: rgba(255, 255, 255, 1);
                    }
                    .active {
                        color: rgba(255, 255, 255, 1);
                        background: rgba(36, 61, 179, 1);
                        z-index: 9999;
                        ::v-deep .nav-link {
                            color: rgba(255, 255, 255, 1);
                        }
                    }
                }
            }
            .wxCode {
                position: relative;
                &:hover {
                    .wx-code-box {
                        display: block;
                        z-index: 9999;
                        position: absolute;
                        top: 80;
                    }
                }
            }
            &:hover :nth-child(2) {
                .nav-children {
                    display: block;
                    z-index: 9999;
                }
            }
            .router-link-active {
                background: rgba(36, 61, 179, 1);
                color: rgba(255, 255, 255, 1);
                font-size: 14px;
            }
        }
    }
}
.footer {
    width: 100%;
    height: 325px;
    background: rgba(244, 245, 247, 1);
    -moz-user-select: none; /* 火狐 */
    -webkit-user-select: none; /* webkit浏览器 */
    -ms-user-select: none; /* IE10 */
    -khtml-user-select: none; /* 早期浏览器 */
    .container {
        width: 1200px;
        height: 325px;
        margin: 0 auto;
        .footer-content {
            display: flex;
            justify-content: space-between;
            // flex-wrap: wrap;
            position: relative;
            h4 {
                font-size: 25px;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                line-height: 62px;
                padding: 40px 0 0 20px;
                margin: 0;
            }
            .footer-left {
                h4 {
                    padding-top: 20px;
                    padding-left: 0;
                }
                ul {
                    margin: 0;
                    list-style: none;
                    width: 1170px;
                    display: flex;
                    flex-wrap: wrap;
                    align-content: flex-start;
                    padding-left: 0;
                    justify-content: space-between;
                    li {
                        width: 150px;
                        height: 50px;
                        margin-top: 20px;
                        a {
                            text-decoration: none;
                            color: rgba(51, 51, 51, 1);
                        }
                        img {
                            width: 100%;
                            height: 100%;
                            display: block;
                        }
                    }
                }
            }
            .footer-bottom {
                width: 100%;
                position: absolute;
                bottom: -90px;
                .footer-number {
                    width: 414px;
                    display: block;
                    text-align: center;
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(153, 153, 153, 1);
                    line-height: 28px;
                    margin: 0 auto;
                    a {
                        text-decoration: none;
                    }
                }
            }
        }
        .footer-right {
            position: relative;
            bottom: 380px;
            left: 1220px;
            z-index: 9999;
            width: 180px;
            height: 180px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
            h4 {
                font-size: 20px;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                line-height: 40px;
                text-align: center;
                padding: 0;
                padding-top: 17px;
                margin: 0;
            }
            .img {
                width: 90px;
                height: 90px;
                margin: 0 auto;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .code-title {
                width: 100%;
                display: block;
                text-align: center;
                margin-left: 0;
                margin-right: 0;
                font-size: 13px;
                font-weight: 400;
                color: rgba(102, 102, 102, 1);
                line-height: 26px;
            }
        }
    }
}
.bright {
    background-color: rgba(255, 255, 255, 1);
}
</style>
